import { Component, OnInit, NgModule } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    autoplay: false,
    items: 1,
    navSpeed: 100,
    nav: true,
    navText: null,
    responsive: {
      940: {
        items: 1
      }
    }
  }
  //slides = [];
  //public slidesStore: Slide[] = [];
  innerHtml = "";

  constructor(public _ui: UtilsService, ) {
    this.innerHtml = "./assets/carousel/13.mp4"
  }


  ngOnInit() {
    /*this.slides.push({ image: './assets/carousel/1.jpg' });
    this.slides.push({ image: './assets/carousel/3.jpg' });
    this.slides.push({ image: './assets/carousel/7.jpg' });
    this.slides.push({ image: './assets/carousel/12.jpg' });*/
    /*let s = new Slide;
    s.id = "1";
    s.src = "./assets/carousel/1.jpg";

    this.slidesStore.push(s);

    s = new Slide;
    s.id = "2";
    s.src = "./assets/carousel/3.jpg";

    this.slidesStore.push(s);

    s = new Slide;
    s.id = "3";
    s.src = "./assets/carousel/7.jpg";

    this.slidesStore.push(s);*/
  }

}

/*export class Slide {
  id: string;
  src: string;
  alt: string = "";
  title: string = "";
}*/